import React from 'react'
import PowerCountcompo from '../../../../../../component/Maindashboardright/PowerCountcompo'


export default function PowerCount() {
  return (
    <div>
      <PowerCountcompo count={ "0"} />
    </div>
  )
}
